"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _BSNeo3_instances, _BSNeo3_getLedgerTransport, _BSNeo3_setTokens, _BSNeo3_buildTransferInvocation;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSNeo3 = void 0;
const bs_asteroid_sdk_1 = require("@cityofzion/bs-asteroid-sdk");
const neon_dappkit_1 = require("@cityofzion/neon-dappkit");
const neon_js_1 = require("@cityofzion/neon-js");
const BSNeo3Helper_1 = require("./helpers/BSNeo3Helper");
const DoraBDSNeo3_1 = require("./services/blockchain-data/DoraBDSNeo3");
const FlamingoEDSNeo3_1 = require("./services/exchange-data/FlamingoEDSNeo3");
const DoraESNeo3_1 = require("./services/explorer/DoraESNeo3");
const NeonDappKitLedgerServiceNeo3_1 = require("./services/ledger/NeonDappKitLedgerServiceNeo3");
const GhostMarketNDSNeo3_1 = require("./services/nft-data/GhostMarketNDSNeo3");
const FlamingoSwapServiceNeo3_1 = require("./services/swap/FlamingoSwapServiceNeo3");
const BSNeo3Constants_1 = require("./constants/BSNeo3Constants");
const RpcBDSNeo3_1 = require("./services/blockchain-data/RpcBDSNeo3");
class BSNeo3 {
    constructor(blockchainName, network, getLedgerTransport) {
        _BSNeo3_instances.add(this);
        _BSNeo3_getLedgerTransport.set(this, void 0);
        network = network !== null && network !== void 0 ? network : BSNeo3Constants_1.BSNeo3Constants.DEFAULT_NETWORK;
        this.blockchainName = blockchainName;
        this.ledgerService = new NeonDappKitLedgerServiceNeo3_1.NeonDappKitLedgerServiceNeo3(this, getLedgerTransport);
        __classPrivateFieldSet(this, _BSNeo3_getLedgerTransport, getLedgerTransport, "f");
        this.bip44DerivationPath = BSNeo3Constants_1.BSNeo3Constants.DEFAULT_BIP44_DERIVATION_PATH;
        this.setNetwork(network);
    }
    generateSigningCallback(account, isLedger) {
        return __awaiter(this, void 0, void 0, function* () {
            const neonJsAccount = new neon_js_1.wallet.Account(account.key);
            if (isLedger) {
                if (!this.ledgerService.getLedgerTransport)
                    throw new Error('You must provide a getLedgerTransport function to use Ledger');
                if (typeof account.bip44Path !== 'string')
                    throw new Error('Your account must have bip44 path to use Ledger');
                const ledgerTransport = yield this.ledgerService.getLedgerTransport(account);
                return {
                    neonJsAccount,
                    signingCallback: this.ledgerService.getSigningCallback(ledgerTransport, account),
                };
            }
            return {
                neonJsAccount,
                signingCallback: neon_js_1.api.signWithAccount(neonJsAccount),
            };
        });
    }
    createSwapService() {
        return new FlamingoSwapServiceNeo3_1.FlamingoSwapServiceNeo3(this.network, this);
    }
    testNetwork(network) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockchainDataServiceClone = new RpcBDSNeo3_1.RpcBDSNeo3(network, this.feeToken, this.claimToken, this.tokens);
            yield blockchainDataServiceClone.getBlockHeight();
        });
    }
    setNetwork(network) {
        __classPrivateFieldGet(this, _BSNeo3_instances, "m", _BSNeo3_setTokens).call(this, network);
        this.network = network;
        this.blockchainDataService = new DoraBDSNeo3_1.DoraBDSNeo3(network, this.feeToken, this.claimToken, this.tokens);
        this.exchangeDataService = new FlamingoEDSNeo3_1.FlamingoEDSNeo3(network);
        this.nftDataService = new GhostMarketNDSNeo3_1.GhostMarketNDSNeo3(network);
        this.explorerService = new DoraESNeo3_1.DoraESNeo3(network);
    }
    validateAddress(address) {
        return neon_js_1.wallet.isAddress(address, 53);
    }
    validateEncrypted(encryptedKey) {
        return neon_js_1.wallet.isNEP2(encryptedKey);
    }
    validateKey(key) {
        return neon_js_1.wallet.isWIF(key) || neon_js_1.wallet.isPrivateKey(key);
    }
    validateNameServiceDomainFormat(domainName) {
        return domainName.endsWith('.neo');
    }
    generateAccountFromMnemonic(mnemonic, index) {
        bs_asteroid_sdk_1.keychain.importMnemonic(Array.isArray(mnemonic) ? mnemonic.join(' ') : mnemonic);
        const bip44Path = this.bip44DerivationPath.replace('?', index.toString());
        const childKey = bs_asteroid_sdk_1.keychain.generateChildKey('neo', bip44Path);
        const key = childKey.getWIF();
        const { address } = new neon_js_1.wallet.Account(key);
        return { address, key, type: 'wif', bip44Path };
    }
    generateAccountFromPublicKey(publicKey) {
        if (!neon_js_1.wallet.isPublicKey(publicKey))
            throw new Error('Invalid public key');
        const account = new neon_js_1.wallet.Account(publicKey);
        return {
            address: account.address,
            key: account.publicKey,
            type: 'publicKey',
        };
    }
    generateAccountFromKey(key) {
        const type = neon_js_1.wallet.isWIF(key) ? 'wif' : neon_js_1.wallet.isPrivateKey(key) ? 'privateKey' : undefined;
        if (!type)
            throw new Error('Invalid key');
        const { address } = new neon_js_1.wallet.Account(key);
        return { address, key, type };
    }
    decrypt(encryptedKey, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = yield neon_js_1.wallet.decrypt(encryptedKey, password);
            return this.generateAccountFromKey(key);
        });
    }
    encrypt(key, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield neon_js_1.wallet.encrypt(key, password);
        });
    }
    calculateTransferFee(param) {
        return __awaiter(this, void 0, void 0, function* () {
            const { neonJsAccount } = yield this.generateSigningCallback(param.senderAccount, param.isLedger);
            const invoker = yield neon_dappkit_1.NeonInvoker.init({
                rpcAddress: this.network.url,
                account: neonJsAccount,
            });
            const invocations = __classPrivateFieldGet(this, _BSNeo3_instances, "m", _BSNeo3_buildTransferInvocation).call(this, param, neonJsAccount);
            const { total } = yield invoker.calculateFee({
                invocations,
                signers: [],
            });
            return total.toString();
        });
    }
    transfer(param) {
        return __awaiter(this, void 0, void 0, function* () {
            const { neonJsAccount, signingCallback } = yield this.generateSigningCallback(param.senderAccount, param.isLedger);
            const invoker = yield neon_dappkit_1.NeonInvoker.init({
                rpcAddress: this.network.url,
                account: neonJsAccount,
                signingCallback: signingCallback,
            });
            const invocations = __classPrivateFieldGet(this, _BSNeo3_instances, "m", _BSNeo3_buildTransferInvocation).call(this, param, neonJsAccount);
            const transactionHash = yield invoker.invokeFunction({
                invocations,
                signers: [],
            });
            return param.intents.map(() => transactionHash);
        });
    }
    claim(account, isLedger) {
        return __awaiter(this, void 0, void 0, function* () {
            const { neonJsAccount, signingCallback } = yield this.generateSigningCallback(account, isLedger);
            const facade = yield neon_js_1.api.NetworkFacade.fromConfig({ node: this.network.url });
            return yield facade.claimGas(neonJsAccount, {
                signingCallback: signingCallback,
            });
        });
    }
    resolveNameServiceDomain(domainName) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const parser = neon_dappkit_1.NeonParser;
            const invoker = yield neon_dappkit_1.NeonInvoker.init({ rpcAddress: this.network.url });
            const response = yield invoker.testInvoke({
                invocations: [
                    {
                        scriptHash: BSNeo3Constants_1.BSNeo3Constants.NEO_NS_HASH,
                        operation: 'ownerOf',
                        args: [{ type: 'String', value: domainName }],
                    },
                ],
            });
            if (response.stack.length === 0) {
                throw new Error((_a = response.exception) !== null && _a !== void 0 ? _a : 'unrecognized response');
            }
            const parsed = parser.parseRpcResponse(response.stack[0], {
                type: 'Hash160',
            });
            return parser.accountInputToAddress(parsed.replace('0x', ''));
        });
    }
}
exports.BSNeo3 = BSNeo3;
_BSNeo3_getLedgerTransport = new WeakMap(), _BSNeo3_instances = new WeakSet(), _BSNeo3_setTokens = function _BSNeo3_setTokens(network) {
    const tokens = BSNeo3Helper_1.BSNeo3Helper.getTokens(network);
    this.tokens = tokens;
    this.feeToken = tokens.find(token => token.symbol === 'GAS');
    this.burnToken = tokens.find(token => token.symbol === 'NEO');
    this.claimToken = tokens.find(token => token.symbol === 'GAS');
}, _BSNeo3_buildTransferInvocation = function _BSNeo3_buildTransferInvocation({ intents, tipIntent }, account) {
    const concatIntents = [...intents, ...(tipIntent ? [tipIntent] : [])];
    return concatIntents.map(intent => {
        return {
            operation: 'transfer',
            scriptHash: intent.tokenHash,
            args: [
                { type: 'Hash160', value: account.address },
                { type: 'Hash160', value: intent.receiverAddress },
                {
                    type: 'Integer',
                    value: intent.tokenDecimals
                        ? neon_js_1.u.BigInteger.fromDecimal(intent.amount, intent.tokenDecimals).toString()
                        : intent.amount,
                },
                { type: 'Any', value: null },
            ],
        };
    });
};
